import i18next from "i18next"

import { AppFunctions } from "@others/AppFunctions.ts"
import { AppLanguages } from "@constants/AppLanguages.ts"
import { AxiosHeaders, InternalAxiosRequestConfig } from "axios"

export const APP_ENVIRONMENT_HEADER = "X-App-Environment"

export const applyAppRequestMetadata = (config: InternalAxiosRequestConfig) => {
	const lang = i18next.language || AppLanguages.DEFAULT
	const headers = AxiosHeaders.from(config.headers || {})

	headers.set(APP_ENVIRONMENT_HEADER, AppFunctions.getViteEnv("VITE_APP_ENV"))

	config.headers = headers
	config.params = {
		...(config.params || {}),
		lang,
	}

	return config
}
